import { createClient, postRequestFactory, SaveOperation } from '@infuse/api/common';
import { commandPermissions } from './command-permissions';

const client = createClient('/rest/operator-api/charging-stations');

export const deleteChargingStation: SaveOperation<void, void, string> = postRequestFactory<void, void, string>(client, {
  pattern: '/{chargingStationId}/delete',
  permissionId: commandPermissions.DELETE_CHARGING_STATION
});
